module.exports = __webpack_public_path__ + "img/increase.6a0829ed.png";